export const style = {
  section: {
    padding: `60px 0 60px 0`
  },
  spacer: {
    border: 0,
    margin: `30px 0`,
    borderTop: `#ddd 1px solid`,
    borderBottom: `white 1px solid`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Games/style/main.js